import { atomWithQuery } from 'jotai-tanstack-query';
import { atomWithHash } from 'jotai-location';
import { atom } from 'jotai';
import axiosApiInstance from '../../../api/axiosClient';
import type { Campaign } from './types';

// --- Filters (URL-hash persisted) ---

export const campaignSearchAtom = atomWithHash<string | undefined>('campaignSearch', undefined);
export const campaignStatusAtom = atomWithHash<string | undefined>('campaignStatus', undefined);
export const campaignBrandAtom = atomWithHash<string | undefined>('campaignBrand', undefined);

// View mode: 'table' (default) | 'board' (kanban).
export type CampaignViewMode = 'table' | 'board';
export const campaignViewModeAtom = atomWithHash<CampaignViewMode>('campaignView', 'table');

// --- Data atoms (match the creators module pattern: atomWithQuery backed by
// jotai-tanstack-query's shared QueryClient, so invalidateQueries from a
// mutation triggers an automatic refetch on the active subscription).

export const campaignsAtom = atomWithQuery<Campaign[]>((get) => ({
    queryKey: [
        'campaigns',
        'items',
        get(campaignSearchAtom),
        get(campaignStatusAtom),
        get(campaignBrandAtom)
    ],
    queryFn: async () => {
        const { data } = await axiosApiInstance.get<Campaign[]>('/api/campaigns/items', {
            params: {
                search: get(campaignSearchAtom) || undefined,
                status: get(campaignStatusAtom) || undefined,
                brand: get(campaignBrandAtom) || undefined,
            }
        });
        return data ?? [];
    }
}));

export const campaignDetailAtom = atom((_get) => ({ id: undefined as number | undefined }));
